/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  FindAllInAppNotificationsParams,
  InAppCustomerNotificationDto,
  MarkInAppNotificationsAsReadPayload,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class InAppNotificationController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags in-app-notification-controller
   * @name MarkInAppNotificationsAsRead
   * @request PUT:/api/v1/inapp-notification/markAsRead
   */
  markInAppNotificationsAsRead = (
    data: MarkInAppNotificationsAsReadPayload,
    params: RequestParams = {},
  ) =>
    this.http.request<string[], any>({
      path: `/v1/inapp-notification/markAsRead`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static markInAppNotificationsAsReadPath = '/v1/inapp-notification/markAsRead'
  static markInAppNotificationsAsReadMethod = 'PUT'
  /**
   * No description
   *
   * @tags in-app-notification-controller
   * @name FindAllInAppNotifications
   * @request GET:/api/v1/inapp-notification
   */
  findAllInAppNotifications = (
    query: FindAllInAppNotificationsParams,
    params: RequestParams = {},
  ) =>
    this.http.request<InAppCustomerNotificationDto[], any>({
      path: `/v1/inapp-notification`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static findAllInAppNotificationsPath = '/v1/inapp-notification'
  static findAllInAppNotificationsMethod = 'GET'
  /**
   * No description
   *
   * @tags in-app-notification-controller
   * @name CountUnreadInAppNotifications
   * @request GET:/api/v1/inapp-notification/unreadCount
   */
  countUnreadInAppNotifications = (params: RequestParams = {}) =>
    this.http.request<number, any>({
      path: `/v1/inapp-notification/unreadCount`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static countUnreadInAppNotificationsPath = '/v1/inapp-notification/unreadCount'
  static countUnreadInAppNotificationsMethod = 'GET'
}
